import { render, staticRenderFns } from "./BelSarAdmin.vue?vue&type=template&id=918bc3a2&scoped=true"
import script from "./BelSarAdmin.vue?vue&type=script&lang=js"
export * from "./BelSarAdmin.vue?vue&type=script&lang=js"
import style0 from "./BelSarAdmin.vue?vue&type=style&index=0&id=918bc3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918bc3a2",
  null
  
)

export default component.exports